module.exports = __webpack_public_path__ + "static/media/not-found.03091355.png";